const base = {
  introText: 'برای بررسی دقیق نیاز شما، اطلاعات زیر را تکمیل کنید.',
  expectedResponseHours: 24,
  maxAttachments: 5,
  maxAttachmentSizeMb: 10,
};

const make = (id, label, type = 'text', extra = {}) => ({
  id, label, type, required: false, placeholder: '', helpText: '', options: [], isActive: true, ...extra,
});

const forms = {
  'website-design': [
    make('website_type', 'نوع وب‌سایت موردنظر', 'select', { required: true, options: ['شرکتی', 'فروشگاهی', 'شخصی/رزومه', 'آموزشی', 'خبری/محتوایی', 'سامانه اختصاصی', 'سایر'] }),
    make('current_website', 'آدرس وب‌سایت فعلی', 'url'),
    make('estimated_pages', 'تعداد تقریبی صفحات', 'number'),
    make('required_features', 'امکانات مهم موردنیاز', 'textarea', { required: true }),
  ],
  'logo-design': [
    make('brand_name', 'نام برند', 'text', { required: true }),
    make('industry', 'حوزه فعالیت برند', 'text', { required: true }),
    make('logo_style', 'سبک مورد علاقه', 'checkbox', { options: ['مینیمال', 'تایپوگرافی', 'نشانه تصویری', 'مدرن', 'کلاسیک'] }),
    make('logo_usage', 'کاربردهای اصلی لوگو', 'textarea'),
  ],
  'ui-ux-design': [
    make('platform', 'بستر محصول', 'checkbox', { required: true, options: ['وب‌سایت', 'وب‌اپلیکیشن', 'اپلیکیشن موبایل', 'پنل مدیریت'] }),
    make('screen_count', 'تعداد تقریبی صفحات/اسکرین‌ها', 'number'),
    make('product_stage', 'مرحله فعلی محصول', 'radio', { options: ['فقط ایده', 'وایرفریم آماده', 'محصول فعال', 'بازطراحی محصول موجود'] }),
  ],
  'wordpress-plugin-development': [
    make('plugin_goal', 'افزونه دقیقاً چه کاری باید انجام دهد؟', 'textarea', { required: true }),
    make('website_url', 'آدرس سایت فعلی', 'url'),
    make('integrations', 'اتصال‌های موردنیاز', 'textarea'),
    make('existing_code', 'آیا کد یا نسخه قبلی وجود دارد؟', 'radio', { options: ['بله', 'خیر'] }),
  ],
  'website-support': [
    make('website_url', 'آدرس وب‌سایت', 'url', { required: true, placeholder: 'haryad.com' }),
    make('platform', 'سیستم و فناوری سایت', 'select', { required: true, options: ['وردپرس', 'وردپرس + ووکامرس', 'جوملا', 'دروپال', 'شاپیفای', 'پرستاشاپ', 'اپن‌کارت', 'مجنتو', 'سایت اختصاصی', 'اطلاع ندارم / سایر'] }),
    make('website_type', 'نوع وب‌سایت', 'select', { required: true, options: ['شخصی یا رزومه', 'شرکتی یا خدماتی', 'فروشگاهی', 'آموزشی', 'خبری یا محتوایی', 'عضویتی', 'رزرو یا نوبت‌دهی', 'وب‌اپلیکیشن یا سامانه آنلاین', 'سایر'] }),
    make('support_type', 'مدت قرارداد پشتیبانی', 'radio', { required: true, options: ['پشتیبانی یک‌ماهه', 'پشتیبانی سه‌ماهه', 'پشتیبانی شش‌ماهه', 'پشتیبانی یک‌ساله'] }),
    make('request_kind', 'نوع درخواست', 'radio', { required: true, options: ['درخواست موردی', 'وضعیت اضطراری'] }),
    make('business_impact', 'وضعیت فعلی سایت', 'select', { required: true, options: ['فعال و بدون مشکل جدی؛ نیازمند نگهداری دوره‌ای', 'فعال است اما کند یا ناپایدار است', 'بخشی از سایت یا یک قابلیت مهم دچار اختلال است', 'فروش، رزرو یا پرداخت متوقف شده است', 'سایت از دسترس خارج شده است', 'سایت هک شده یا احتمال آلودگی امنیتی وجود دارد', 'برای تشخیص وضعیت به بررسی فنی نیاز دارم'] }),
    make('needed_services', 'حوزه‌های موردنیاز', 'checkbox', { options: ['به‌روزرسانی فنی', 'بکاپ و بازیابی', 'امنیت', 'سرعت و بهینه‌سازی', 'رفع خطا', 'پایش سایت', 'تغییرات ظاهری یا فنی کوچک', 'ویرایش محتوای موجود', 'افزودن محتوای جدید', 'مدیریت محصولات فروشگاه'] }),
    make('access_status', 'وضعیت دسترسی‌ها', 'radio', { options: ['پنل مدیریت و هاست در دسترس است', 'فقط پنل مدیریت سایت در دسترس است', 'فقط هاست یا سرور در دسترس است', 'دسترسی‌ها نزد طراح یا پشتیبان قبلی است', 'برای تهیه دسترسی‌ها نیاز به راهنمایی دارم'] }),
    make('issue_description', 'خطاها یا نشانه‌های مشاهده‌شده', 'textarea', { placeholder: 'اگر خطایی وجود دارد، متن خطا، زمان شروع، صفحات درگیر و آخرین تغییرات انجام‌شده را بنویسید.' }),
  ],
};

const formSettings = {
  'website-support': {
    introText: 'برای انتخاب پلن یا بررسی مشکل سایت، اطلاعات زیر را تکمیل کنید. رمز عبور، کد ورود یا اطلاعات محرمانه را داخل این فرم ارسال نکنید.',
    expectedResponseHours: 8,
  },
};

export const getDefaultServiceOrderForm = (slug = '') => ({
  ...base,
  ...(formSettings[slug] || {}),
  fields: JSON.parse(JSON.stringify(forms[slug] || [
    make('project_type', 'نوع پروژه', 'text', { required: true }),
    make('requirements', 'نیازها و امکانات اصلی', 'textarea', { required: true }),
  ])),
});
